import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MainComponent} from './main.component';
import {HeaderComponent} from './header/header.component';
import {FooterComponent} from './footer/footer.component';
import {AdminMenuSidebarComponent} from './admin-menu-sidebar/admin-menu-sidebar.component';
import {MenuSidebarComponent} from './menu-sidebar/menu-sidebar.component';
import {TaskSidebarComponent} from './task-sidebar/task-sidebar.component';
import {ControlSidebarComponent} from './control-sidebar/control-sidebar.component';
import {SuperAdminMainComponentComponent} from './super-admin-main-component/super-admin-main-component.component';
import {ReactiveFormsModule} from '@angular/forms';
import {ProfabricComponentsModule} from '@profabric/angular-components';
import {RouterModule} from '@angular/router';
import {MenuItemComponent} from './menu-item/menu-item.component';
import {PaginatorModule} from 'primeng/paginator';
import {DialogModule} from 'primeng/dialog';
import {TableModule} from 'primeng/table';
import {NotificationsComponent} from './header/notifications/notifications.component';
import {EmailHidePipe} from '@/common/Pipe/hidden-mail.pipe';

@NgModule({
    declarations: [
        MainComponent,
        HeaderComponent,
        FooterComponent,
        AdminMenuSidebarComponent,
        MenuSidebarComponent,
        ControlSidebarComponent,
        SuperAdminMainComponentComponent,
        MenuSidebarComponent,
        MenuItemComponent,
        NotificationsComponent,
        EmailHidePipe
    ],
    imports: [
        CommonModule,
        TaskSidebarComponent,
        ReactiveFormsModule,
        ProfabricComponentsModule,
        RouterModule,
        PaginatorModule,
        DialogModule,
        TableModule
    ],
    exports: [
        MainComponent,
        HeaderComponent,
        FooterComponent,
        AdminMenuSidebarComponent,
        MenuSidebarComponent,
        TaskSidebarComponent,
        ControlSidebarComponent,
        SuperAdminMainComponentComponent,
        EmailHidePipe
    ]
})
export class CoreModule {}
